<template>
    <div class="w-full flex flex-wrap">
        <div class="flex flex-col w-full" :id="printPreviewId">
            <div class="">
                <div class="inline-block min-w-full align-middle">
                    <div class="flex">
                        <page-headline>{{$t('pages.analytics.tabs.details.title')}}</page-headline>
                        <prev-next-auction
                            class="flex pt-5 pb-3"
                            :auctions="auctions"
                            :current="auction"
                            @update="showPrevOrNext"
                        />
                    </div>
                    <div v-if="auction">
                        <div class="text-xl mt-3">{{auction.name}}</div>
                        <div class="py-3 text-lg">
                            <auction-performance-details-overview
                                :performance-details="performanceDetails"
                                :auction="auction"/>
                        </div>

                        <div class="mt-10 w-full hide-on-print">
                            <tabs ref="tabs" class="w-full">
                                <tab :title="$t('pages.analytics.details.tabs.actual.title')" class="pl-5 mt-5">
                                    <pyramid-levels-performance :auction="auction" :merch-sales="merchSales" :performance-details="performanceDetails" />
                                </tab>
                                <tab :title="$t('pages.analytics.details.tabs.plan.title')" class="pl-5 mt-5">
                                    <pyramid-levels-planning :levels="originLevels"/>
                                </tab>
                            </tabs>
                        </div>
                        <div>
                            <div class="mt-10 w-full hidden show-on-print">
                                <h2 class="section-title mb-3">{{$t('pages.analytics.details.tabs.actual.title')}}</h2>
                                <pyramid-levels-performance :auction="auction" :merch-sales="merchSales" :performance-details="performanceDetails" />
                            </div>
                            <div class="mt-10 w-full hidden show-on-print">
                                <h2 class="section-title mb-3">{{$t('pages.analytics.details.tabs.plan.title')}}</h2>
                                <pyramid-levels-planning :levels="originLevels"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="!auction" class="m-3">{{$t('shared.pyramid_auction.no_auction')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import { Link } from '@inertiajs/vue2';
import PageHeadline from "../PageHeadline";
import ValueBox from "../ValueBox";
import Tab from '@/Shared/Tab';
import Tabs from '@/Shared/Tabs';
import PyramidLevelsPerformance from "../Tables/PyramidLevelsPerformance";
import PyramidLevelsPlanning from "../Tables/PyramidLevelsPlanning";
import Stats from "../Stats";
import Stat from "../Stat";
import PrevNextAuction from "../PrevNextAuction";
import AuctionPerformanceDetailsOverview from "./AuctionPerformanceDetailsOverview";


export default {
    layout: Layout,
    components: {
        PrevNextAuction,
        Link,
        Icon,
        PageHeadline,
        ValueBox,
        Tabs,
        Tab,
        PyramidLevelsPerformance,
        AuctionPerformanceDetailsOverview,
        PyramidLevelsPlanning,
        Stats,
        Stat
    },
    props: {
        auction: {
            type: Object,
            default: null
        },
        merchSales: Array,
        initialAuctions: [],
        originLevels: Array,
        performanceDetails: Object
    },
    data() {
        return {
            printPreviewId: '',
            auctions: this.initialAuctions
        }
    },
    created() {
        this.generateId();
    },
    computed: {
        visitors() {
            return this.auction.visitors ? this.auction.visitors : 1; // TODO: implement visitors
        },
        floorSales() {
            return this.auction.levels.reduce((acc, level) => {
                return acc + level.quantity_used * level.price;
            }, 0);
        },
        bidsPerVisitor() {
            if(this.auction.bids.length === 0 ) {
                return 0;
            }
            return this.auction.visitors / this.auction.bids.length;
        },
        quantityActual() {
            return this.auction.article_quantity;
        },
        quantityPlan() {
            return this.auction.originLevels ? this.auction.originLevels.available_quantity : this.quantityActual;
        },
        averagePrice() {
            const soldQty = this.soldQuantity;
            if(0 === soldQty) {
                return 0;
            }
            return this.floorSales === 0 ? 0: this.floorSales / soldQty;
        },
        executedLevels() {
            return this.auction.levels.reduce((accumulator, level) => {
                if(['passed'].indexOf(level.state) >= 0) {
                    return accumulator + 1;
                }
                return accumulator;
            }, 0);
        },
        levelsPlanned() {
            return this.auction.planned ? this.auction.planned.levels.length : this.auction.levels.length;
        },
        soldQuantity() {
            return this.auction.levels.reduce((accumulator, level) => {
                return accumulator + level.quantity_used;
            }, 0);
        }
    },
    methods: {
        generateId() {
            if(this.printPreviewId.length === 0 ){
               this.printPreviewId = 'auction-performance-details-' + Math.floor(Math.random() * 100000000000).toString();
            }
        },
        showPrevOrNext(auctionId){
            this.$emit('go-to-details', auctionId)
        },
        setAuctions(auctions) {
            this.auctions = auctions;
        }
    }
}
</script>
